/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime.js';
import { CfarItineraryFromJSON, CfarItineraryToJSON, } from './CfarItinerary.js';
import { CfarOfferFromJSON, CfarOfferToJSON, } from './CfarOffer.js';
import { CfarStatusFromJSON, CfarStatusToJSON, } from './CfarStatus.js';
import { CfarTaxFromJSON, CfarTaxToJSON, } from './CfarTax.js';
/**
 * Check if a given object implements the CfarContract interface.
 */
export function instanceOfCfarContract(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "reference" in value;
    isInstance = isInstance && "offers" in value;
    isInstance = isInstance && "itinerary" in value;
    isInstance = isInstance && "coveragePercentage" in value;
    isInstance = isInstance && "coverage" in value;
    isInstance = isInstance && "premium" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "taxesTotal" in value;
    isInstance = isInstance && "createdDateTime" in value;
    isInstance = isInstance && "expiryDateTime" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "extAttributes" in value;
    return isInstance;
}
export function CfarContractFromJSON(json) {
    return CfarContractFromJSONTyped(json, false);
}
export function CfarContractFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'reference': json['reference'],
        'offers': (json['offers'].map(CfarOfferFromJSON)),
        'itinerary': CfarItineraryFromJSON(json['itinerary']),
        'coveragePercentage': json['coverage_percentage'],
        'coverage': json['coverage'],
        'premium': json['premium'],
        'currency': json['currency'],
        'taxesTotal': json['taxes_total'],
        'taxes': !exists(json, 'taxes') ? undefined : (json['taxes'].map(CfarTaxFromJSON)),
        'createdDateTime': (new Date(json['created_date_time'])),
        'expiryDateTime': (new Date(json['expiry_date_time'])),
        'status': CfarStatusFromJSON(json['status']),
        'pnrReference': !exists(json, 'pnr_reference') ? undefined : json['pnr_reference'],
        'extAttributes': json['ext_attributes'],
        'exerciseUrl': !exists(json, 'exercise_url') ? undefined : json['exercise_url'],
    };
}
export function CfarContractToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'reference': value.reference,
        'offers': (value.offers.map(CfarOfferToJSON)),
        'itinerary': CfarItineraryToJSON(value.itinerary),
        'coverage_percentage': value.coveragePercentage,
        'coverage': value.coverage,
        'premium': value.premium,
        'currency': value.currency,
        'taxes_total': value.taxesTotal,
        'taxes': value.taxes === undefined ? undefined : (value.taxes.map(CfarTaxToJSON)),
        'created_date_time': (value.createdDateTime.toISOString()),
        'expiry_date_time': (value.expiryDateTime.toISOString()),
        'status': CfarStatusToJSON(value.status),
        'pnr_reference': value.pnrReference,
        'ext_attributes': value.extAttributes,
        'exercise_url': value.exerciseUrl,
    };
}
